import { storageName, flagSchema, valueSchema } from "./ConfigCatFlagModel";

declare global {
  interface Window {
    ff: { [key: string]: string | boolean | number };
  }
}

export const getFeatureFlagOverrides = () => {
  const overrides = sessionStorage.getItem(storageName);

  if (overrides !== "undefined" && overrides !== null) {
    try {
      const parsed = JSON.parse(overrides);
      const data = flagSchema.safeParse(parsed);

      if (data.success) {
        const result = data.data;
        result.forEach((flag) => {
          flag.value = getParsedValue(flag.value);
        });
        return result;
      }
    } catch (error) {
      console.error("Failed to parse overrides:", error);
    }
  }

  return [];
};

export const getConfigCatFlags = () =>
  Object.entries(window.ff || {})
    .filter(([, value]) => valueSchema.safeParse(value).success)
    .map(([key, value]) => ({
      name: key,
      value: valueSchema.parse(value),
    }));

export const getParsedValue = (value: string | boolean | number) => {
  if (typeof value === "string") {
    if (["true", "false"].includes(value)) {
      return value === "true";
    }

    const parsedNumber = Number(value);
    if (!isNaN(parsedNumber)) {
      return parsedNumber;
    }
  }

  return value;
};
